import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { Card, CardBody } from '@/shared/components/Card';
import { LoginForm } from './components/LoginForm';
import { useSession } from '@/core/auth/useSession';
import { ROUTES } from '@/core/config/routes';
export function LoginPage() {
    const { autenticado, hidratado } = useSession();
    if (hidratado && autenticado) {
        return _jsx(Navigate, { to: ROUTES.dashboard, replace: true });
    }
    return (_jsx(Card, { className: "w-full max-w-md", children: _jsxs(CardBody, { className: "py-8", children: [_jsxs("div", { className: "mb-6 text-center", children: [_jsx("h1", { className: "text-2xl font-bold text-text-primary", children: "Ingresar a SSC" }), _jsx("p", { className: "mt-1 text-sm text-text-secondary", children: "Us\u00E1 tu email y contrase\u00F1a corporativos." })] }), _jsx(LoginForm, {})] }) }));
}
